import React, { useEffect } from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import {
  Container,
  FormikWrapper,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Node,
  ViewFilters,
  useViewFilterQuery,
} from '@uncinc/react-drupal-core';
import {
  ImmutableEntity,
  Pager as PageType,
} from '@uncinc/react-drupal-core/types';

import { NodeDocument } from '../../../types/uncinc_profile/nodes';
import { ViewFilter, Pager } from '../../../components';
import {
  Filter,
  FilterProps,
} from '../../../components/ViewFilter';

import {
  TAXONOMY_MEDIA_CATEGORY_PUBLICATION,
  TAXONOMY_MEDIA_CATEGORY_CODE,
} from '../../../config/constants';

import './style.scss';

interface DocumentsFilteredProps {
  entities: Immutable.List<ImmutableEntity<NodeDocument>>;
  pager: Immutable.List<ImmutableEntity<PageType>>;
  filters: Filter[];
  defaultFilterValues: Filter[];
  mediaCategoryId: number;
}

const DocumentsFiltered: React.FC<DocumentsFilteredProps> = ({
  entities, pager, filters, mediaCategoryId, defaultFilterValues,
}) => {
  const totalPages = Number(pager.getIn(['total_pages']));
  const { page, setCurrentPage, setFilters } = useViewFilterQuery();
  const currentPage: number = Number(page) + 1;
  const { t } = useTranslation();
  const isNotOfTypeMagazine = [
    TAXONOMY_MEDIA_CATEGORY_PUBLICATION,
    TAXONOMY_MEDIA_CATEGORY_CODE,
  ].includes(mediaCategoryId);
  const isTypePublication = mediaCategoryId === TAXONOMY_MEDIA_CATEGORY_PUBLICATION;

  const colClasses = isNotOfTypeMagazine ? 'col-md-6' : 'col-lg-4';

  useEffect(() => {
    setFilters(defaultFilterValues);
  }, [defaultFilterValues]);

  return (
    <FormikWrapper>
      <Container>
        {isTypePublication && (
          <ViewFilters
            viewId="documents_filtered"
            display="default"
            onResetFilter={() => { }}
            onFilterUpdate={(field: any, value: any) => {
              setFilters({
                ...filters,
                [field]: value,
              });
            }}
            onRender={(data: FilterProps) => {
              const filterId = data.filter.get('id', null);
              const defaultValue = defaultFilterValues?.[filterId];

              return (
                <ViewFilter
                  {...data}
                  filters={filters}
                  defaultValue={defaultValue}
                />
              );
            }}
          />
        )}

        {entities.size === 0 && (
          <div className="View__Results__EmptyState">
            <h3>{t('pages.search.result_empty_title')}</h3>
            <p>{t('pages.search.result_empty_body')}</p>
          </div>
        )}

        <div className="row">
          {
            entities.map((entity) => {
              const uuid = entity.getIn(['uuid', 0, 'value']);
              const langcode = entity.getIn(['langcode', 0, 'value']);
              const key = `${uuid}:${langcode}`;

              return (
                <div className={`col-12 ${colClasses}`} key={key}>
                  <Node
                    entity={entity}
                    viewMode="teaser"
                  />
                </div>
              );
            })
          }
        </div>

        <div className="ViewDocumentsFiltered__pager">
          <Pager
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
        </div>
      </Container>
    </FormikWrapper>
  );
};

export default DocumentsFiltered;
